module.exports = __webpack_public_path__ + "img/campana.cdbccae9.png";